import * as React from 'react';
import { UitkText } from 'uitk-react-text';

interface DurationStopsByProps {
  durationAndStops: string;
  layoverInformation?: string;
}

export const DurationStops = ({ durationAndStops, layoverInformation }: DurationStopsByProps) => (
  <>
    <UitkText theme="primary" size={200} className="all-t-margin-one" dataTestId="journey-duration">
      {durationAndStops}
    </UitkText>
    {layoverInformation && (
      <UitkText spacing="one" size={200} overflow="truncate" dataTestId="layovers">
        {layoverInformation}
      </UitkText>
    )}
  </>
);
